<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="doRollup">
      <el-form-item label="成品物料">
        <el-input v-model="materialCode" readonly size="small" style="width:200px" placeholder="点击选择">
          <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="BOM版本"><el-input v-model="bomVersion" size="small" clearable style="width:120px" placeholder="空=默认" /></el-form-item>
      <el-form-item label="BOM类型">
        <el-select v-model="bomType" size="small" style="width:100px">
          <el-option label="MBOM" value="mbom" /><el-option label="EBOM" value="ebom" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmCostRollup:list')" type="primary" size="small" :loading="loading" @click="doRollup">滚算</el-button>
      </el-form-item>
    </el-form>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />

    <el-card v-if="result" shadow="never" style="margin-bottom:12px">
      <div>成品：{{ result.materialCode }} {{ result.materialName }}</div>
      <div>版本：{{ result.bomType }} / {{ result.bomVersion }}</div>
      <div>滚算成本（{{ result.costBasis || '采购未税价' }}）：<strong>{{ result.rolledCost }}</strong>
        <span v-if="result.targetCost != null"> | 目标成本：{{ result.targetCost }} | 差异：{{ result.variance }}</span>
      </div>
    </el-card>
    <el-alert v-if="result && result.missingCostMaterials && result.missingCostMaterials.length" type="warning" :closable="false"
      :title="`以下物料未维护采购未税价，已按 0 计算：${result.missingCostMaterials.join('、')}`" style="margin-bottom:12px" />

    <el-table :data="result ? (result.lines || []) : []" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="level" label="层级" width="60" header-align="center" align="center" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="quantity" label="用量" width="80" header-align="center" align="right" />
      <el-table-column prop="loss" label="损耗%" width="80" header-align="center" align="right" />
      <el-table-column prop="effectiveQuantity" label="累计需用量" width="110" header-align="center" align="right" />
      <el-table-column prop="unitCost" label="单位成本" width="100" header-align="center" align="right" />
      <el-table-column prop="extendedCost" label="扩展成本" width="100" header-align="center" align="right" />
      <el-table-column prop="leaf" label="叶子" width="60" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.leaf ? '是' : '否' }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmCostRollup',
  components: { MaterialSelector },
  data() {
    return {
      materialId: '', materialCode: '', bomVersion: '', bomType: 'mbom',
      result: null, loading: false, materialSelectorVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    onMaterialSelect(row) {
      this.materialId = row.materialId
      this.materialCode = row.materialCode
      this.materialSelectorVisible = false
    },
    doRollup() {
      if (!this.materialId) { this.$message.warning('请选择成品物料'); return }
      this.loading = true
      request.post('/plm/cost/rollup', {
        materialId: this.materialId,
        bomVersion: this.bomVersion || '',
        bomType: this.bomType || 'mbom'
      }).then(res => { this.result = res.data || null }).catch(() => { this.result = null }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
